import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { JobEffects } from './job.effects';
import { JobReducers, STORE_FEATURE_KEY_JOB } from './job.reducer';
import { JobSelectors } from './job.selectors';
import { JobService } from './job.service';

@NgModule({
    imports: [
        CommonModule,
        UpgradeModule,
        FormsModule,
        NgrxFormsModule,
        ReactiveFormsModule,
        TooltipModule,
        EffectsModule.forFeature([JobEffects]),
        StoreModule.forFeature(STORE_FEATURE_KEY_JOB, JobReducers)
    ]
    ,
    declarations: [
    ],
    providers: [
        JobService,
        JobSelectors
    ]
})
export class JobModule {
}
